const MINUTE_MS = 60_000

/** A length of time in whole minutes, as a person reads it: "3 h 20 min", "45 min", "under 1 min". */
export function formatActivityDuration(ms: number): string {
    const minutes = Math.floor(Math.max(0, ms) / MINUTE_MS)
    if (minutes < 1) return 'under 1 min'
    const hours = Math.floor(minutes / 60)
    const rest = minutes % 60
    if (hours === 0) return `${rest} min`
    return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`
}
